"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Image = exports.LottieContainer = exports.Description = exports.Title = void 0;
const native_1 = __importDefault(require("styled-components/native"));
const atoms_1 = require("../../atoms");
exports.Title = native_1.default(atoms_1.PText) `
  text-align: center;
  color: ${({ theme }) => theme.bpCore.colors.text};
  padding: 16px 16px 2px 16px;
`;
exports.Description = native_1.default(atoms_1.PText) `
  text-align: center;
  opacity: 0.8;
  color: ${({ theme }) => theme.bpCore.colors.text};
  padding: 0 16px;
`;
exports.LottieContainer = native_1.default.View `
  height: auto;
  width: 100%;
  aspect-ratio: 1.33;
`;
exports.Image = native_1.default.Image `
  height: auto;
  aspect-ratio: 1.33;
  width: 100%;
`;
